// sort-imports-ignore
import '@js-joda/timezone';
import 'src/components/table-view/app-wide';
import 'src/lib/table';
import { localforage } from 'src/lib/serialization/localForage';
import { container } from 'src/StaticContainer';
// Styles
import 'src/styles/index.css';

const log = container.get('Logger').getSubLogger({ name: 'prelude' });

window.localforage = localforage;
window.logger = log;
